import React, { useEffect, useState } from 'react';
// @ts-ignore
import styles from './PatientsFilledQuestionnairesList.module.scss';
import FlatList from '../../../Base/Components/FlatList';
import useQuestionnaireResults from '../../Hooks/useQuestionnaireResults';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import PatientsFilledQuestionnairesFilter, {
	PatientsFilledQuestionnairesFilterValues,
} from './PatientsFilledQuestionnairesFilter';
import PatientsFilledQuestionnairesListItem from './PatientsFilledQuestionnairesListItem';
import { QuestionnaireModule } from '../../Enums/QuestionnaireModule.enum';

interface Props {
	patientId: string;
	module?: QuestionnaireModule;
	roundValuesTo?: number;
}

const WRAPPER_ID = 'patientsFilledQuestionnairesListWrapper';

const PatientsFilledQuestionnairesList: React.FC<Props> = ({
	patientId,
	module,
	roundValuesTo,
}) => {
	const {
		getQuestionnaireResults,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	} = useQuestionnaireResults();
	const [flatData, setFlatData] = useState<any[]>([]);
	const [hasMoreData, setHasMoreData] = useState<boolean>(false);
	const [filter, setFilter] =
		useState<PatientsFilledQuestionnairesFilterValues>({
			patientId: patientId,
			module: module,
			excludeQuestionnaireCodes: [
				'meddibaby_entry_questionnaire',
				'meddibaby_regular_inspection',
				'meddibaby_end_questionnaire',
			],
		});

	useEffect(() => {
		loadQuestionnaireResults();
	}, [page]);

	useEffect(() => {
		loadQuestionnaireResults(true);
	}, [filter]);

	useEffect(() => {
		if (data) {
			const questionnaireResultsData = data?.questionnaireResults?.data;
			const totalPages = data?.questionnaireResults?.meta?.totalPages;
			const page = data?.questionnaireResults?.meta?.page;

			if (questionnaireResultsData) {
				if (page && page > 1) {
					setFlatData(prevFlatData => [
						...prevFlatData,
						...questionnaireResultsData,
					]);
				} else {
					setFlatData(questionnaireResultsData);
				}
			}

			if (totalPages && page) {
				setHasMoreData(totalPages > page);
			}
		}
	}, [data]);

	const loadQuestionnaireResults = (reset: boolean = false) => {
		if (reset && page != 1) {
			setPage(1);
			return;
		}
		getQuestionnaireResults(filter);
	};

	return (
		<div className={styles.wrapper}>
			<PatientsFilledQuestionnairesFilter
				onFilter={filter => setFilter(filter)}
				patientId={patientId}
			/>
			<ScrollContainer wrapperId={WRAPPER_ID}>
				<FlatList
					onRefresh={loadQuestionnaireResults}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={WRAPPER_ID}
					renderItem={item => (
						<PatientsFilledQuestionnairesListItem
							id={item.id}
							createdAt={item.createdAt}
							questionnaire={item.questionnaire.title}
							patientName={item.user.profile.fullName}
							questionnaireId={item.questionnaire.id}
							questionnaireCode={item.questionnaire.code}
							patientId={item.user.id}
							doctor={item.scheduledBy?.profile?.fullName}
							roundValuesTo={roundValuesTo}
						/>
					)}
				/>
			</ScrollContainer>
		</div>
	);
};

export default PatientsFilledQuestionnairesList;
